import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const OurSolution = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
   <section className="lg:py-28 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            // data-aos="fade-down"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            // data-aos="fade-up"
            // data-aos-delay="100"
          >
            We architected and delivered a state-of-the-art document management system using a modular monolithic
            architecture built with Java and Spring Boot. The solution leverages ElasticSearch for lightning-fast
            full-text search, Tesseract OCR engine for converting image-based documents into searchable text, and
            Spring Security with Keycloak for enterprise-grade authentication and authorization. The entire platform
            was containerized with Docker and deployed with automated Jenkins CI/CD pipelines, monitoring via
            Prometheus and Grafana, ensuring 99.9% uptime.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            // data-aos="fade-right"
            // data-aos-delay="200"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li><strong>OCR Implementation:</strong> Integrated Tesseract OCR to automatically convert image-based documents (scans, PDFs) into searchable text, expanding searchable content by 300%</li>
            <li ><strong>ElasticSearch Integration:</strong> Implemented distributed search cluster enabling sub-0.5 second searches across 10+ million documents with advanced filtering and faceting</li>
            <li ><strong>Hierarchical Workflow Engine:</strong> Designed flexible approval workflows supporting document creation, uploading, multi-level review, approval, rejection, and resubmission cycles</li>
            <li ><strong>Enterprise Integrations:</strong> Built custom connectors for seamless data exchange with SAP, ADP, and OpenText using REST APIs and message queues</li>
            <li ><strong>Security & Compliance:</strong> Implemented role-based access control (RBAC), document-level permissions, audit logging, and encryption at rest and in transit</li>
            <li><strong>Automated CI/CD:</strong> Jenkins pipelines for automated testing, deployment, monitoring, and rollback capabilities ensuring zero-downtime deployments</li>
            <li ><strong>Modular Architecture:</strong> Microservices-ready design with clearly separated modules for document storage, search, workflow, and integrations</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8 mt-8"
            // data-aos="fade-down"
            // data-aos-delay="600"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">10M+</h5>
              <p className="text-[#9E9E9E]">Documents managed in first year, scalable to 100M+</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">&lt;0.5s</h5>
              <p className="text-[#9E9E9E]">Search response time even across large datasets</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">40%</h5>
              <p className="text-[#9E9E9E]">Reduction in document processing time via workflow automation</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">30%</h5>
              <p className="text-[#9E9E9E]">Decrease in unauthorized access incidents</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">25%</h5>
              <p className="text-[#9E9E9E]">Improvement in customer satisfaction scores</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">2,500+</h5>
              <p className="text-[#9E9E9E]">Enterprise customers successfully migrated and onboarded</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
            // data-aos="fade-up"
            // data-aos-delay="950"
          >
            The platform transformed document management operations across 2,500+ organizations, delivering unprecedented
            search performance, workflow efficiency, and security. The modular architecture positioned the client for
            future growth while seamless enterprise integrations enabled rapid customer onboarding and expanded market
            reach across Asia-Pacific and European markets.
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurSolution
